<template>
    <sm-spinner v-if="showSpinner" :show="showSpinner" />
  <form v-else class="sm-list__popup-form" @submit.prevent="() => false">
    <h4>Deactivate {{ popup.item.full_name }}</h4>
    <div v-if="hasVirtualPhone" class="sm-note-important">
      <p class="sm-txt-upper">
        <span class="sm-red sm-txt-strong">Important: </span>
        <span class="sm-txt-strong"
          >THIS CUSTOMER HAS AN ACTIVE VIRTUAL PHONE NUMBER LINKED TO THEIR ACCOUNT.</span
        >
      </p>
      <span
        >Canceling the subscription will permanently release the number, and it cannot be recovered. Please confirm that 
        the customer has explicitly agreed to release all associated numbers before proceeding.</span
      >
      <checkbox-block
        v-model="confirmed"
        :text="`I understand`"
      />
    </div>
    <div class="sm-list__popup-form-radio deactivate">
      <radiobutton-block
        v-for="(item, index) in popup.options"
        :key="index"
        v-model="curDeactivationOption"
        :text="item.title"
        :description="
          index === 1 ? $moment(item.value).format('MMM DD, YYYY') : ''
        "
        :name="'deactiavte'"
        :checked="curDeactivationOption.title === popup.options[index].title"
        @input="
          curDeactivationOption = item;
          popup.options[2].value = '';
        "
      >
        <div
          v-if="
            index === 2 &&
              curDeactivationOption.title === popup.options[index].title
          "
          class="radio-datepicker"
        >
          <datepicker-wrap
            v-model="popup.options[2].value"
            :notBefore="new Date()"
          />
        </div>
      </radiobutton-block>
    </div>
    <btn-block
      :type="'warning'"
      @click="confirmDeactivate"
      :classes="[{ disabled: disabled }]"
      :text="`Deactivate Customer`"
    />
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import Radiobutton from '@/components/Radiobutton';
import DatepickerWrap from '@/components/DatepickerWrap';
import Checkbox from '@/components/Checkboxes';
import Spinner from '@/components/Spinner';
export default {
  name: 'deactivate-customer',
  components: {
    'radiobutton-block': Radiobutton,
    'checkbox-block': Checkbox,
    'datepicker-wrap': DatepickerWrap,
    'sm-spinner': Spinner,
  },
  props: {
    popup: {
      type: Object,
      required: true,
    },
    curDeactivationOption: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hasVirtualPhone: false,
      confirmed: false,
      showSpinner: false,
    };
  },
  computed: {
    disabled() {
      return this.curDeactivationOption.value === '' || !this.confirmed && this.hasVirtualPhone;
    },
  },
  async created() {
    try {
      this.showSpinner = true;
      this.hasVirtualPhone =
        (await this.getPhoneList(this.popup.item.id)).total_count > 0;
    } catch (error) {
      console.error('Error fetching phone list:', error);
    }finally {
      this.showSpinner = false;
    }
  },
  methods: {
    ...mapActions({
      getPhoneList: 'wrappers/getCustomerPhoneList', //'account/getPhoneList',
    }),
    confirmDeactivate() {
      this.$emit('deactivate', {
        id: this.popup.item.id,
        expires_on: this.curDeactivationOption.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
